export const environment = {
  production: true,
  base_url:'https://foodieshome.com/api',
};
